module.exports = __webpack_public_path__ + "img/stoke sixth form.c4b52cf9.jpg";